<mat-form-field [style.width]="width">
  <mat-label class="font-semibold mb-2">
    {{ label | translate }}
    <small *ngIf="required" class="text-gray-400">
      ({{ 'shared:required' | translate }})
    </small>
  </mat-label>
  <mat-select
    [(ngModel)]="language"
    (ngModelChange)="valueChanged.next(language)"
    [required]="required">
    <mat-option value="es">{{ 'language.es' | translate }}</mat-option>
    <mat-option value="en">{{ 'language.en' | translate }}</mat-option>
    <mat-option value="pt">{{ 'language.pt' | translate }}</mat-option>
  </mat-select>
  <mat-error *ngIf="!language && required">
    {{ 'shared:isRequired' | translate }}
  </mat-error>
</mat-form-field>
